import {formatISO} from "date-fns";

import AddressService from "../../../../services/AddressService";
import WeatherService from "../../../../services/WeatherService";


export default class EnvironmentManager
{

    constructor(geoOptions)
    {
        this.geoOptions = geoOptions || {enableHighAccuracy: false, maximumAge: 0, timeout: 7000};
        this.addressService = new AddressService();
        this.weatherService = new WeatherService();
        this.environBag = {};

        this.geolocation = navigator.geolocation;
        this.geolocationEnabled = true; //??? how do I check this?
    }

    async fetchEnvironment(gcid, token, onValueChange, onlineInfo)
    {
        navigator.geolocation.getCurrentPosition(
            async (position) => 
            {
                var lat = position.coords.latitude;
                var lng = position.coords.longitude;
                this.environBag["timestamp"] = position.timestamp;
                onValueChange("timestamp", position.timestamp);
                this.environBag["latitude"] = lat.toFixed(4);
                onValueChange("latitude", lat.toFixed(4));
                this.environBag["longitude"] = lng.toFixed(4);
                onValueChange("longitude", lng.toFixed(4));
                this.environBag["altitude"] = position.coords.altitude;
                onValueChange("altitude", position.coords.altitude);
                console.log("Latitude is :", position.coords.latitude);
                console.log("Longitude is :", position.coords.longitude);

                if (!onlineInfo.isConnected)
                {
                    // we want to tell the system to check BEFORE uploading
                    this.environBag["updateOnUpload"] = true;
                    onValueChange("updateOnUpload", true);
                    this.environBag["historical_datetime"] = formatISO(new Date());
                    onValueChange("historical_datetime", formatISO(new Date()));
                    return;
                }
                var addressResult = await this.fetchAddressData(lat, lng, onValueChange, gcid, token);
                var weatherResult = await this.fetchWeatherData(lat, lng, onValueChange, gcid, token);
            },
            (error) => 
            {
                this.environBag["geolocation_haserror"] = true;
                onValueChange("geolocation_haserror", true);
                this.environBag["geolocation_errorcode"] = error.code;
                onValueChange("geolocation_errorcode", error.code);
                this.environBag["geolocation_errormessage"] = error.message;
                onValueChange("geolocation_errormessage", error.message);
            },
            this.geoOptions
        );

    } 


    async fetchAddressData(lat, lng, onValueChange, gcid, token)
    {
        var addressResult = await this.addressService.fetchAddressData(lat, lng, gcid, token);
        console.group("Address");
        console.info(addressResult);
        console.groupEnd();
        if (addressResult.hasError)
        {
            this.environBag["isenabled"] = false;
            onValueChange("isenabled", false);
            this.environBag["address_haserror"] = true;
            onValueChange("address_haserror", true);
            this.environBag["address_errormessage"] = addressResult.messages;
            onValueChange("address_errormessage", addressResult.messages);
        }
        else 
        {
          this.environBag["isenabled"] = true;
          onValueChange("isenabled", true);
          this.environBag["address"] = addressResult.dataResult.results[0].formattedAddress;
          onValueChange("address", addressResult.dataResult.results[0].formattedAddress);
          this.environBag["placeid"] = addressResult.dataResult.results[0].placeId;
          onValueChange("placeid", addressResult.dataResult.results[0].placeId);
        }
    }

    async updateObservationWithAddress(observation, lat, lng, gcid, token)
    {
        var addressResult = await this.addressService.fetchAddressData(lat, lng, gcid, token);
        console.group("Address");
        console.info(addressResult);
        console.groupEnd();
        var environNode = observation.data.Environment;
        if (!environNode) observation.data.Environment = {};
        var rawNode = observation.data.Raw;
        if (addressResult.hasError)
        {
            rawNode["isenabled"] = false;
            rawNode["address_haserror"] = true;
            rawNode["address_errormessage"] = addressResult.messages;
        }
        else 
        {
            rawNode["isenabled"] = true;
            rawNode["address"] = addressResult.dataResult.results[0].formattedAddress;
            rawNode["placeid"] = addressResult.dataResult.results[0].placeId;
            environNode["address"] = addressResult.dataResult.results[0].formattedAddress;
            environNode["placeid"] = addressResult.dataResult.results[0].placeId;
        }
        observation.data.Raw = rawNode;
        observation.data.Environment = environNode;
        return observation;
    }

    
    async fetchWeatherData(lat, lng, onValueChange, gcid, token)
    {
        var weatherResult = await this.weatherService.fetchWeatherData(lat, lng, gcid, token);
        console.group("Weather");
        console.info(weatherResult);
        console.groupEnd();
        if (weatherResult.hasError)
        {
            this.environBag["weather_haserror"] = true;
            onValueChange("weather_haserror", true);
            this.environBag["weather_error"] = addressResult.messages;
            onValueChange("weather_error", addressResult.messages);
        }
        else
        {
            this.environBag["weatherobservedtime"] = weatherResult.dataResult.current.observation_time;
            onValueChange("weatherobservedtime", weatherResult.dataResult.current.observation_time);
            this.environBag["weatherlocaltime"] = weatherResult.dataResult.location.localtime;
            onValueChange("weatherlocaltime", weatherResult.dataResult.location.localtime);
            this.environBag["weatherlocaltimeepoch"] = weatherResult.dataResult.location.localtime_epoch;
            onValueChange("weatherlocaltimeepoch", weatherResult.dataResult.location.localtime_epoch);
            this.environBag["ambienttemperature"] = weatherResult.dataResult.current.temperature;
            onValueChange("ambienttemperature", weatherResult.dataResult.current.temperature);
            this.environBag["feelslike"] = weatherResult.dataResult.current.feelslike;
            onValueChange("feelslike", weatherResult.dataResult.current.feelslike);
            this.environBag["temperatureunit"] = weatherResult.dataResult.request.unit;
            onValueChange("temperatureunit", weatherResult.dataResult.request.unit);
            this.environBag["cloudcover"] = weatherResult.dataResult.current.cloudcover;
            onValueChange("cloudcover", weatherResult.dataResult.current.cloudcover);
            this.environBag["airpressure"] = weatherResult.dataResult.current.pressure;
            onValueChange("airpressure", weatherResult.dataResult.current.pressure);
            this.environBag["humidity"] = weatherResult.dataResult.current.humidity;
            onValueChange("humidity", weatherResult.dataResult.current.humidity);
            this.environBag["weatherdescript"] = weatherResult.dataResult.current.weather_descriptions[0];
            onValueChange("weatherdescript", weatherResult.dataResult.current.weather_descriptions[0]);
            this.environBag["winddegree"] = weatherResult.dataResult.current.wind_degree;
            onValueChange("winddegree", weatherResult.dataResult.current.wind_degree);
            this.environBag["winddirection"] = weatherResult.dataResult.current.wind_dir;
            onValueChange("winddirection", weatherResult.dataResult.current.wind_dir);
            this.environBag["windspeed"] = weatherResult.dataResult.current.wind_speed;
            onValueChange("windspeed", weatherResult.dataResult.current.wind_speed);
            this.environBag["humidity"] = weatherResult.dataResult.current.humidity;
            onValueChange("humidity", weatherResult.dataResult.current.humidity);
          var weather = { current: weatherResult.dataResult.current, location: weatherResult.dataResult.location };
        }
    }


    async fetchHistoricWeatherData(lat, lng, isoInspectionDateTime, onValueChange, gcid, token)
    {
        var weatherResult = await this.weatherService.fetchWeatherData(lat, lng, gcid, token);
        console.group("Weather");
        console.info(weatherResult);
        console.groupEnd();
        if (weatherResult.hasError)
        {
            this.environBag["weather_haserror"] = true;
            onValueChange("weather_haserror", true);
            this.environBag["weather_error"] = addressResult.messages;
            onValueChange("weather_error", addressResult.messages);
        }
        else
        {
            this.environBag["weatherobservedtime"] = weatherResult.dataResult.current.observation_time;
            onValueChange("weatherobservedtime", weatherResult.dataResult.current.observation_time);
            this.environBag["weatherlocaltime"] = weatherResult.dataResult.location.localtime;
            onValueChange("weatherlocaltime", weatherResult.dataResult.location.localtime);
            this.environBag["weatherlocaltimeepoch"] = weatherResult.dataResult.location.localtime_epoch;
            onValueChange("weatherlocaltimeepoch", weatherResult.dataResult.location.localtime_epoch);
            this.environBag["ambienttemperature"] = weatherResult.dataResult.current.temperature;
            onValueChange("ambienttemperature", weatherResult.dataResult.current.temperature);
            this.environBag["feelslike"] = weatherResult.dataResult.current.feelslike;
            onValueChange("feelslike", weatherResult.dataResult.current.feelslike);
            this.environBag["temperatureunit"] = weatherResult.dataResult.request.unit;
            onValueChange("temperatureunit", weatherResult.dataResult.request.unit);
            this.environBag["cloudcover"] = weatherResult.dataResult.current.cloudcover;
            onValueChange("cloudcover", weatherResult.dataResult.current.cloudcover);
            this.environBag["airpressure"] = weatherResult.dataResult.current.pressure;
            onValueChange("airpressure", weatherResult.dataResult.current.pressure);
            this.environBag["humidity"] = weatherResult.dataResult.current.humidity;
            onValueChange("humidity", weatherResult.dataResult.current.humidity);
            this.environBag["weatherdescript"] = weatherResult.dataResult.current.weather_descriptions[0];
            onValueChange("weatherdescript", weatherResult.dataResult.current.weather_descriptions[0]);
            this.environBag["winddegree"] = weatherResult.dataResult.current.wind_degree;
            onValueChange("winddegree", weatherResult.dataResult.current.wind_degree);
            this.environBag["winddirection"] = weatherResult.dataResult.current.wind_dir;
            onValueChange("winddirection", weatherResult.dataResult.current.wind_dir);
            this.environBag["windspeed"] = weatherResult.dataResult.current.wind_speed;
            onValueChange("windspeed", weatherResult.dataResult.current.wind_speed);
            this.environBag["humidity"] = weatherResult.dataResult.current.humidity;
            onValueChange("humidity", weatherResult.dataResult.current.humidity);
          var weather = { current: weatherResult.dataResult.current, location: weatherResult.dataResult.location };
        }
    }


    async updateObservationWithHistoricalWeatherData(observation, lat, lng, isoInspectionDateTime, gcid, token)
    {
        var environNode = observation.data.Environment;
        if (!environNode) observation.data.Environment = {};
        var rawNode = observation.data.Raw;
        var weatherResult = await this.weatherService.fetchHistoricalWeatherData(lat, lng, isoInspectionDateTime, gcid, token);
        if (weatherResult.hasError)
        {
            rawNode["weather_haserror"] = true;
            rawNode["weather_error"] = addressResult.messages;
        }
        else
        {
            rawNode["weatherobservedtime"] = isoInspectionDateTime;
            rawNode["weatherlocaltime"] = isoInspectionDateTime;
            rawNode["weatherlocaltimeepoch"] = "";
            rawNode["ambienttemperature"] = weatherResult.dataResult.temperature;
            rawNode["feelslike"] = weatherResult.dataResult.feelslike;
            rawNode["temperatureunit"] = "";
            rawNode["cloudcover"] = weatherResult.dataResult.cloudcover;
            rawNode["airpressure"] = weatherResult.dataResult.pressure;
            rawNode["humidity"] = weatherResult.dataResult.humidity;
            rawNode["weatherdescript"] = weatherResult.dataResult.weather_descriptions[0];
            rawNode["winddegree"] = weatherResult.dataResult.wind_degree;
            rawNode["winddirection"] = weatherResult.dataResult.wind_dir;
            rawNode["windspeed"] = weatherResult.dataResult.wind_speed;
            environNode["feelslike"] = weatherResult.dataResult.feelslike;
            environNode["temperatureunit"] = "";
            environNode["cloudcover"] = weatherResult.dataResult.cloudcover;
            environNode["airpressure"] = weatherResult.dataResult.pressure;
            environNode["humidity"] = weatherResult.dataResult.humidity;
            environNode["weatherdescript"] = weatherResult.dataResult.weather_descriptions[0];
            environNode["winddegree"] = weatherResult.dataResult.wind_degree;
            environNode["winddirection"] = weatherResult.dataResult.wind_dir;
            environNode["windspeed"] = weatherResult.dataResult.wind_speed;
          var weather = { current: weatherResult.dataResult.current, location: weatherResult.dataResult.location };
        }
        observation.data.Raw = rawNode;
        observation.data.Environment = environNode;
        return observation;
    }
    
}